import {
  BarChart3, BookOpen, Briefcase, ChevronRight, Coffee, Database,
  ExternalLink, Monitor, Settings, Target, TrendingUp,
} from 'lucide-react'
import ScheduleWidget from '../widgets/ScheduleWidget'
import PrismPlayerPanel from '../widgets/PrismPlayerPanel'
import './HomePage.css'

const MODULE_CARDS = [
  {
    sectionId: 'liveodds', tabId: 'odds-table', label: 'Live Odds',
    desc: 'Validated cross-book prices, best lines, positive EV, arbitrage, middles, and movement',
    Icon: BarChart3, color: '#24d7a0', stats: 'Market data',
  },
  {
    sectionId: 'mlb', tabId: 'overview', label: 'MLB Intelligence',
    desc: 'Schedule, lineups, pitchers, umpires, predictions, and game-level monitoring',
    Icon: Monitor, color: '#4f8ee8', stats: 'Game day',
  },
  {
    sectionId: 'theodds', tabId: 'sports-browser', label: 'Market Explorer',
    desc: 'Browse sports, events, regions, scores, event markets, and historical endpoints',
    Icon: TrendingUp, color: '#f3bd4c', stats: 'Multi-sport',
  },
  {
    sectionId: 'stats', tabId: 'mlb-stats', label: 'Stats Lab',
    desc: 'League, team, and player analytics across MLB, NBA, NFL, NHL, CFB, CBB, and soccer',
    Icon: Database, color: '#24c9dc', stats: '7 sports',
  },
  {
    sectionId: 'research', tabId: 'models', label: 'Model Research',
    desc: 'Forecasts, methodology, backtests, walk-forward evidence, and model diagnostics',
    Icon: BookOpen, color: '#c177e8', stats: 'Evidence',
  },
  {
    sectionId: 'strategies', tabId: 'strategy-tracker', label: 'Portfolio',
    desc: 'Strategy tracking, ROI, drawdown, risk, efficient frontier, and allocation',
    Icon: Target, color: '#ef699f', stats: 'Performance',
  },
  {
    sectionId: 'infrastructure', tabId: 'monitoring', label: 'Operations',
    desc: 'Source health, Oracle VM, scraper fleet, latency, storage, proof, and incidents',
    Icon: Settings, color: '#9b7cf0', stats: 'Proof',
  },
  {
    sectionId: 'jobs', tabId: 'jobs-browser', label: 'Sportsbook Jobs',
    desc: 'Career intelligence from sportsbook and sports-technology companies',
    Icon: Briefcase, color: '#f58442', stats: 'Industry',
  },
]

export default function HomePage({ navigateTo, openEvent }) {
  return (
    <div className="hp-container">
      <section className="hp-hero">
        <div className="hp-hero-left">
          <div className="hp-module-pill-strip" aria-label="Module navigation">
            {MODULE_CARDS.map((module) => (
              <button key={module.sectionId} className="hp-module-pill" onClick={() => navigateTo(module.sectionId, module.tabId)}>
                <span>{module.label}</span>
              </button>
            ))}
          </div>
          <h1 className="hp-hero-title"><span className="hp-alpha">&#x03B1;</span><span className="hp-wordmark">bet</span></h1>
          <p className="hp-hero-subtitle">
            Sportsbook prices, market movement, predictive research, and execution proof in one operating surface.
          </p>
        </div>
      </section>

      {/* Collapsed by default: the iframe is not mounted until expanded, so
          a closed panel costs no catalog fetch and no CDN scripts. */}
      <PrismPlayerPanel />

      <ScheduleWidget variant="homepage" navigateTo={navigateTo} onEventSelect={openEvent} />

      <div className="hp-section-row"><span className="hp-section-label">Product modules</span></div>
      <div className="hp-modules">
        {MODULE_CARDS.map((module) => (
          <button
            key={module.sectionId}
            className="hp-module-card"
            onClick={() => navigateTo(module.sectionId, module.tabId)}
            style={{ '--mod-color': module.color }}
          >
            <div className="hp-module-header"><module.Icon size={24} className="hp-module-icon" /><span className="hp-module-stats">{module.stats}</span></div>
            <h3 className="hp-module-label">{module.label}</h3>
            <p className="hp-module-desc">{module.desc}</p>
            <div className="hp-module-arrow"><ChevronRight size={16} /></div>
          </button>
        ))}
      </div>

      <div className="hp-support">
        <a href="https://buymeacoffee.com/abet" target="_blank" rel="noopener noreferrer" className="hp-coffee-btn"><Coffee size={16} /><span>Support ABET</span></a>
        <a href="https://x.com/ABEThq" target="_blank" rel="noopener noreferrer" className="hp-twitter-link"><ExternalLink size={14} /><span>@ABEThq on X</span></a>
      </div>
    </div>
  )
}
